import { CombinedGraphQLErrors, ErrorLike } from '@apollo/client'

/** Extract the `errorType` extension field on GraphQL errors */
export function deriveErrorTypes(error: ErrorLike | null | undefined): Array<string> {
  return (CombinedGraphQLErrors.is(error) ? error.errors : [])
    .filter(error => error.extensions && (error.extensions.errorType || error.extensions.code))
    .map(error => {
      return (error.extensions?.errorType ?? error.extensions?.code) as string
    })
}
